// extracted by mini-css-extract-plugin
export default {"background":"Login_background__EEl9S","login":"Login_login__x7f0g","copy":"Login_copy__OEhYF"};